import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect, Router } from 'react-router-dom';
import Login from '../screens/Login';
import FourOFour from '../screens/FourOFour';
import { history } from '../utils';
import { connect } from 'react-redux';
import { initializeUserAction, isAuthenticated } from '../redux/user';
import { setRoute, fetchBrackets } from '../redux/app';
import Brackets from '../screens/Brackets';
import EditBracket from '../screens/EditBracket';
import Participant from '../screens/Participant';
import TreeDataProvider from './TreeProvider';
import BracketNodeEditor from './BracketNodeEditor';
import { BASENAME } from '../config';

class AppRouter extends React.Component {
  state = {
    renderRoutes: false,
  };
  componentDidMount() {
    this.props.setRoute(history);
    history.listen((location) => {
      this.props.setRoute(location);
    });
    this.props
      .initialize()
      .then(this.props.fetchBrackets)
      .catch(() => {})
      .finally(() => {
        this.setState({
          renderRoutes: true,
        });
      });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isAuthenticated && this.props.isAuthenticated) {
      this.props.fetchBrackets();
    }
  }

  renderIfAuthenticated = (Comp) => (props) => {
    if (!this.props.isAuthenticated) {
      return <Redirect to={BASENAME + '/login'} />;
    }

    return React.createElement(Comp, props);
  };

  renderIfNotAuthenticated = (Comp) => (props) => {
    if (this.props.isAuthenticated) {
      return <Redirect to={BASENAME + '/'} />;
    }

    return React.createElement(Comp, props);
  };

  render() {
    if (!this.state.renderRoutes) {
      return null;
    }

    return (
      <Router history={history}>
        <Switch>
          <Route
            path={BASENAME + '/login'}
            exact
            render={this.renderIfNotAuthenticated(Login)}
          />
          <Route
            path={BASENAME + '/admin/okta-login'}
            exact
            render={this.renderIfNotAuthenticated(Login)}
          />
          <Route
            path={BASENAME + '/'}
            exact
            render={this.renderIfAuthenticated(Brackets)}
          />
          <Route
            path={BASENAME + '/tree'}
            render={({ match: { url } }) => (
              <>
                <TreeDataProvider
                  url={url}
                  renderFunction={this.renderIfAuthenticated}
                >
                  <Route
                    path={'/edit/:id/participant/:participantId/edit'}
                    exact
                    component={Participant}
                  />
                  <Route
                    path={['/edit/:id', '/edit/:id/node/:nodeId']}
                    exact
                    component={EditBracket}
                  />
                  <Route path={'/create'} exact component={EditBracket} />
                  <Route
                    path={'/edit/:id/participant/create'}
                    component={Participant}
                  />
                </TreeDataProvider>
                <Route
                  path={`${url}/edit/:id/node/:nodeId`}
                  exact
                  render={this.renderIfAuthenticated(BracketNodeEditor)}
                />
              </>
            )}
          />
          <Route path="*" component={FourOFour} />
        </Switch>
      </Router>
    );
  }
}

AppRouter.propTypes = {
  initialize: PropTypes.func,
  setRoute: PropTypes.func,
  fetchBrackets: PropTypes.func,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticated(state),
});

const mapDispatchToProps = (dispatch) => ({
  initialize: () => dispatch(initializeUserAction()),
  fetchBrackets: () => dispatch(fetchBrackets()),
  setRoute: (route) => dispatch(setRoute(route)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppRouter);
